import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class EquipmentDbTableDefinition extends DbTableDefinition {
    tableName = 'equipments';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       branchid BIGINT(20),
       branchlabel TEXT,
       equipmentclass TEXT,
       installationsite TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}